import { updateProfile } from "@/api";
import { useAuth } from "@/contexts/auth/useAuth";
import { Edit } from "@mui/icons-material";
import { Box, InputAdornment } from "@mui/material";
import { FormContainer, FormTextFieldElement } from "@rhf-kit/mui";
import { useMutation } from "@tanstack/react-query";
import { enqueueSnackbar } from "notistack";
import { useEffect, useState } from "react";
import { Button } from "../../buttons/Button";

interface FormData {
    firstName: string;
    lastName: string;
}

export const PersonalInformationForm = () => {
    const { user, session } = useAuth();

    const [defaultValues, setDefaultValues] = useState<FormData>({
        firstName: user?.first_name || "",
        lastName: user?.last_name || "",
    });

    useEffect(() => {
        if (user) {
            setDefaultValues({
                firstName: user.first_name,
                lastName: user.last_name,
            });
        }
    }, [user]);

    const profileMutation = useMutation({
        mutationFn: updateProfile,
        onSuccess: () => {
            enqueueSnackbar({
                variant: "success",
                message: "Profile successfully updated",
            });

            session.refresh();
        },
    });

    const handleSubmit = async (formData: FormData) => {
        profileMutation.mutate({
            first_name: formData.firstName,
            last_name: formData.lastName,
        });
    };

    if (!user) {
        return null;
    }

    return (
        <FormContainer values={defaultValues} onSuccess={handleSubmit}>
            <FormTextFieldElement
                id="firstName"
                fullWidth
                required
                name="firstName"
                label="First Name"
                margin="normal"
                slotProps={{
                    input: {
                        endAdornment: (
                            <InputAdornment position="end">
                                <Edit />
                            </InputAdornment>
                        ),
                    },
                }}
            />

            <FormTextFieldElement
                id="lastName"
                fullWidth
                required
                name="lastName"
                label="Last Name"
                margin="normal"
                slotProps={{
                    input: {
                        endAdornment: (
                            <InputAdornment position="end">
                                <Edit />
                            </InputAdornment>
                        ),
                    },
                }}
            />
            <Box mt={2} display="flex">
                <Box flexGrow={1} />
                <Button
                    loading={profileMutation.isPending}
                    variant="contained"
                    color="dark"
                    type="submit"
                    sx={{ borderRadius: 2 }}
                >
                    Save Changes
                </Button>
            </Box>
        </FormContainer>
    );
};
